import { render } from "./RetentionTable.vue?vue&type=template&id=39d382a2"
import script from "./RetentionTable.vue?vue&type=script&lang=js"
export * from "./RetentionTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__